import { render, staticRenderFns } from "./CatalogSlider.vue?vue&type=template&id=da223752&scoped=true&"
import script from "./CatalogSlider.vue?vue&type=script&lang=js&"
export * from "./CatalogSlider.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSlider.vue?vue&type=style&index=0&id=da223752&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da223752",
  null
  
)

export default component.exports